import { BaseApi } from '@/services/api/base-api.ts';
import zodAttendancePaidWorkSumDto from '@/schemas/attendance/zod-AttendancePaidWorkSumDto.js';
import { z } from 'zod';
import zodAttendanceMonthDto from '@/schemas/attendance/zod-AttendanceMonthDto.js';

export type AttendanceMonthSummary = z.infer<
  typeof zodAttendancePaidWorkSumDto
>;

export type AttendanceMonthDto = z.infer<typeof zodAttendanceMonthDto>;

export class AttendanceMonthApi extends BaseApi {
  constructor() {
    super();
  }

  async getSummaryAsync(ccmId: number) {
    return this.requestAsync({
      schema: zodAttendancePaidWorkSumDto,
      url: 'attendance/month/summary',
      query: { ccmId: ccmId },
    });
  }

  async getAsync(emoNo: number, yearMonth: string) {
    return this.requestAsync({
      schema: zodAttendanceMonthDto,
      url: 'attendance/month',
      query: {
        emoNo,
        yearMonth,
      },
    });
  }

  async getDeadlineAsync(yearMonth: string) {
    return this.requestAsync({
      schema: z.boolean(),
      url: `attendance/month/deadline`,
      query: {
        yearMonth: yearMonth,
      },
    });
  }

  async deadlineAsync(yearMonth: string) {
    return this.requestAsync({
      schema: zodAttendanceMonthDto,
      url: `attendance/month/deadline`,
      method: 'post',
      query: { yearMonth: yearMonth },
    });
  }

  async deadlineCancelAsync(yearMonth: string) {
    return this.requestAsync({
      schema: z.boolean(),
      url: `attendance/month/deadline/cancel`,
      method: 'post',
      query: { yearMonth: yearMonth },
    });
  }
  
  async getCancelableDeadlineAsync(yearMonth: string) {
    return this.requestAsync({
      schema: z.boolean(),
      url: `attendance/month/deadline/cancelable`,
      query: {
        yearMonth: yearMonth,
      },
    });
  }
}
